import { createStore } from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import Cookies from 'js-cookie'

import createField from './modules/createField'
import auth from './modules/auth'
import sidebar from './modules/sidebar'
import loading from './modules/loading'
import errors from './modules/errors'

export default createStore({
  plugins: [createPersistedState({
    paths: ['auth'],
    storage: {
      getItem: (key) => Cookies.get(key),
      setItem: (key, value) => Cookies.set(key, value, { expires: 30 }),
      removeItem: (key) => Cookies.remove(key)
    }
  })],
  modules: {
    createField,
    auth,
    sidebar,
    loading,
    errors
  }
})
